import { createApp } from 'vue'
import App from '@/layers/App.vue'
import router from './router/index'
import { createPinia } from 'pinia'

const pinia = createPinia()
const app = createApp(App)

app
.use(router)
.use(pinia)
.mount('#app')

